import { AppPermissions } from 'constants/permissions';

export const permissions = {
  viewPurchaseOrder: [AppPermissions.view_purchaseorder],
  changeOrder: [AppPermissions.view_orders, AppPermissions.change_orders],
  changeNote: [AppPermissions.change_note, AppPermissions.view_note],
};
